import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { ADD_COMMENT_REPLY } from 'root/src/shared/descriptions/endpoints/endpointIds'
import addCommentReply from 'root/src/client/logic/comment/actions/addCommentReply'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

export default payload => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	const res = await dispatch(apiRequest(ADD_COMMENT_REPLY, { ...payload, projectUrl }))
	const { statusCode, body } = res
	if (statusCode === 200) {
		dispatch(addCommentReply(body))
	}
	return res
}
